import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const primaryColor = '#3E63DD';
const primaryColorHover = '#3358D4';
const surfaceColor = '#FFFFFF';
const borderColor = '#E6E8EB';
const textColor = '#11181C';
const mutedTextColor = '#687076';

export const ThemePreset = definePreset(Aura, {
    name: 'delta-theme',
    components: {
        button: {
            root: {
                borderRadius: '8px',
                label: {
                    fontWeight: '500 !important'
                },
                transitionDuration: '0.15s !important',
                primary: {
                    background: primaryColor + '!important',
                    color: '#FFFFFF !important',
                    borderColor: primaryColor + '!important',
                    hoverBackground: primaryColorHover + '!important',
                    hoverBorderColor: primaryColorHover + '!important',
                    activeBackground: primaryColorHover + '!important',
                    activeBorderColor: primaryColorHover + '!important'
                }
            },
            outlined: {
                primary: {
                    color: textColor + ' !important',
                    borderColor: borderColor + ' !important',
                    hoverBackground: surfaceColor + ' !important',
                    activeBackground: surfaceColor + ' !important'
                }
            }
        },

        datepicker: {
            panel: {
                borderRadius: '8px'
            },
            today: {
                color: primaryColor + '!important'
            },
            date: {
                selectedBackground: primaryColor + '!important'
            }
        },

        inputtext: {
            root: {
                background: surfaceColor + ' !important',
                borderColor: borderColor + ' !important',
                borderRadius: '8px',
                color: textColor + ' !important',
                focusBorderColor: primaryColor + ' !important',
                placeholderColor: mutedTextColor + ' !important'
            }
        }
        // --p-datatable-header-cell-sm-padding
        // datatable: {
        //     headerCell: {
        //         color: mutedTextColor + ' !important',
        //         sm: {
        //             padding: '0.6rem 0.5rem !important'
        //         }
        //     }
        // }
    },
    semantic: {
        primary: {
            50: '#EDF2FE',
            100: '#D9E2FC',
            200: '#BCCAF9',
            300: '#9EAEF4',
            400: '#7E8FF0',
            500: primaryColor,
            600: '#3358D4',
            700: '#2847B1',
            800: '#1D358E',
            900: '#152771',
            950: '#0F1B50'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '#f8fafc',
                    100: '#f1f5f9',
                    200: '#e2e8f0',
                    300: '#cbd5e1',
                    400: '#94a3b8',
                    500: '#64748b',
                    600: '#475569',
                    700: '#334155',
                    800: '#1e293b',
                    900: '#0f172a',
                    950: '#020617'
                }
            }
        }
    }
});
